export const COMMON_PAGE_TEXT = {
  FORM_VALIDATION: {
    VALID_EMAIL: 'Enter a valid email',
    VALID_PASSWORD: 'Password should be of minimum 8 characters length',
    PASSWORD_MATCH: 'Passwords must match',
    REQUIRED: 'Required',
  },
  BUTTON: {
    BACK: 'Back',
    DELETE: 'Delete',
    NEXT: 'Next',
    SUBMIT: 'Submit',
    SAVE: 'Save',
    LAST_STEP: 'Last step',
    FINISH: 'Finish',
    CONTINUE: 'Continue',
    PANEL_SELECTION: 'Panel Selection',
    MANAGE: 'Manage',
    MANAGEMODE: 'Manage Mode',
    ALL: 'All',
    ADD_LIST: 'Add Lists',
    EXPORT_APPLICATION_DATA: 'Export Application Data',
  },
  YES: 'Yes',
  NO: 'No',
  SELECT: 'Please select',
  FILE: 'File',
  NA: 'N/A',
};
